export class ReqFormUrlBody {
    [key: string]: string | string[]
}